import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { Benefits } from '../components/Benefits';
import { HowItWorks } from '../components/HowItWorks';
import { PartnersCallout } from '../components/PartnersCallout';
import { Footer } from '../components/Footer';
import { SubscriptionModal } from '../components/SubscriptionModal';
export function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <div className="min-h-screen bg-black" data-id="element-339">
      <Hero onOpenModal={() => setIsModalOpen(true)} data-id="element-340" />
      <Benefits data-id="element-341" />
      <HowItWorks onOpenModal={() => setIsModalOpen(true)} data-id="element-342" />
      <PartnersCallout data-id="element-343" />
      <Footer data-id="element-344" />
      <SubscriptionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-345" />
    </div>;
}